const SDK_VERSION = '7.51.2';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
